export default "__VITE_ASSET__BTf_r88E__"